import React from 'react'
import { ModalConsulta } from '.';
import { Tabela } from '../Basicos';

const TIPOS_DE_ATIVIDADE_SERVICO = ['14', '72'];

function ModalAulasCanceladas(props) {
    const { estrutura } = props;
    const { alunos } = estrutura?.modal;

    const tiposDeAtividade = estrutura?.modal?.exportacao?.paramsExport?.tipos_de_atividade;

    const isServico = React.useMemo(() => {
        if (!tiposDeAtividade || String(tiposDeAtividade) === '0') return true;

        return String(tiposDeAtividade)
            .split(',')
            .map((id) => id.trim())
            .every((id) => TIPOS_DE_ATIVIDADE_SERVICO.includes(id));
    }, [tiposDeAtividade]);

    const columns = React.useMemo(
        () => [{
            Header: "alunos",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Aluno',
                    accessor: 'matricula'
                },
                {
                    Header: 'Nome',
                    accessor: 'nome_aluno',
                },
                {
                    Header: 'CPF',
                    accessor: 'cpf_aluno',
                },
                {
                    Header: 'RG',
                    accessor: 'rg_aluno',
                },
                {
                    Header: 'Celular',
                    accessor: 'celular_aluno',
                },
                {
                    Header: 'Grupo',
                    accessor: 'grupo',
                },
                {
                    Header: isServico ? 'Serviço' : 'Aula',
                    accessor: 'servico',
                },
                {
                    Header: 'Local',
                    accessor: 'local',
                },
                {
                    Header: 'Data',
                    accessor: 'data_ptbr',
                },
                {
                    Header: 'Hora Início',
                    accessor: 'hora_inicio',
                },
                {
                    Header: 'Intervalo Início',
                    accessor: 'intervalo_inicio',
                },
                {
                    Header: 'Intervalo Fim',
                    accessor: 'intervalo_fim',
                },
                {
                    Header: 'Fim',
                    accessor: 'fim',
                },
                {
                    Header: 'Professor',
                    accessor: 'professor',
                },
            ],
        }],
        [isServico]
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={alunos}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalAulasCanceladas;
